module.exports = __webpack_public_path__ + "static/media/UI_img2.f69ae03b.png";